// extracted by mini-css-extract-plugin
module.exports = {"distance":"Distance-module__distance___2arQJ"};